import { getFeatureFlags } from '../../core/featureFlags';
import type { MediaInitiativeConfig } from '../../core/featureFlags';
import type { Preset } from '../../core/types';

export function ttsPolicyInstructions(
  preset: Preset,
  config: MediaInitiativeConfig = getFeatureFlags().ttsInitiative,
): string {
  if (!config.enabled) return '';
  const prompt = config.prompts[preset.ttsGenerationPolicy ?? 'balanced'];
  return typeof prompt === 'string' ? prompt : '';
}
